import React, { useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { BiPlus } from "react-icons/bi";

const FeesPayableEdit = ({ SET_FEES_PAYABLE, apiDatas, setAllowEdit }) => {
  console.log("apiDatas", apiDatas);

  const fee_payable_titles = ["SL. No", "ITEMS", "COST", "REMARKS", "ACTION"];

  const [feesList, setFeesList] = useState([
    {
      item: "",
      cost: "0",
      remark: "",
    },
  ]);

  useEffect(() => {
    if (apiDatas?.contract_fees_payables?.length > 0) {
      setFeesList([...apiDatas?.contract_fees_payables]);
    } else {
      setFeesList([
        {
          item: "",
          cost: "",
          remark: "",
        },
      ]);
    }
  }, [apiDatas]);

  const addNewRow = () => {
    setFeesList([
      ...feesList,
      {
        item: "",
        cost: "",
        remark: "",
      },
    ]);
    setAllowEdit(true);
  };

  const deleteRow = (index) => {
    if (feesList.length <= 1) return false;
    const updatedRows = [...feesList];
    updatedRows.splice(index, 1);
    setFeesList(updatedRows);
    setAllowEdit(true);
  };

  const updateRow = (property, updatedValue, rowIndex) => {
    const updatedList = [...feesList];
    updatedList[rowIndex][property] = updatedValue;
    setFeesList(updatedList);
    setAllowEdit(true);
  };

  useEffect(() => {
    SET_FEES_PAYABLE(feesList);
  }, [feesList]);

  return (
    <>
      <div className="pt-10 ">
        <div className="font-semibold text-xl my-3">
          FEES PAYABLE BY SECOND PARTY
        </div>
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block uppercase">{`Slide / scroll to right >`}</p>
        <div
          className={`grid justify-items-center grid-cols-table-5 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {fee_payable_titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {feesList?.map((list, index) => (
            <React.Fragment key={index+list.item}>
              <p>{index + 1}</p>
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="text"
                defaultValue={list.item}
                onChange={(e) =>
                  updateRow("item", e.target.value?.toUpperCase(), index)
                }
                required
                placeholder="ENTER ITEM"
              />
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="number"
                value={list.cost}
                onChange={(e) => updateRow("cost", e.target.value, index)}
                placeholder="ENTER COST"
                required
              />
              <select
                className="select-sm rounded-sm bg-slate-100"
                type="text"
                value={list.remark}
                onChange={(e) =>
                  updateRow("remark", e.target.value?.toUpperCase(), index)
                }
                required
              >
                <option value="" hidden>
                  Select an Option
                </option>
                <option value="ONE TIME">One Time</option>
                <option value="YEARLY">Yearly</option>
              </select>
              <div className="flex gap-3 w-24 justify-start">
                <button
                  type="button"
                  className={`p-1 px-2 rounded-md ring-1 ring-red bg-red text-white disabled:bg-rose-400 disabled:cursor-not-allowed `}
                  onClick={() => deleteRow(index)}
                  disabled={feesList?.length <= 1}
                  title={`${
                    feesList?.length <= 1 && "At least one row required"
                  }`}
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
                {index === feesList?.length - 1 && (
                  <button
                    className={`p-1 px-2 rounded-md ring-1 ring-slate-600 `}
                    onClick={addNewRow}
                  >
                    <BiPlus size={"1.4rem"} />
                  </button>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-5 `}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default FeesPayableEdit;
